<script setup>
import { Head, Link, useForm } from '@inertiajs/vue3'
import ClientOnly from '@duannx/vue-client-only'
import { Modal } from 'momentum-modal'
import Notifications from "./Components/Notifications.vue";
import Navigation from "./Components/Navigation.vue";
import Footer from "./Components/Footer.vue";
</script>

<template>
    <Head>
        <link rel="alternate" type="application/atom+xml" title="Codecourse courses" href="/feed">
        <link rel="alternate" type="application/atom+xml" title="Codecourse articles" href="/feed/articles">
    </Head>

    <div class="bg-[rgba(8,13,39,1)] relative z-[1] antialiased bg-[url('/images/layout-background.svg')] bg-no-repeat bg-[left_-6em_top_-4em] lg:bg-top xl:bg-left-top">
        <div class="max-w-7xl mx-auto px-6">
            <Navigation />
            <div class="w-full">
                <slot />
            </div>
        </div>
        <Footer />
        <ClientOnly>
            <Modal />
            <Notifications />
        </ClientOnly>
    </div>
</template>
